import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleVsAllChina() {
  return <ArticleTemplate article={articles[5]} />;
}